// src/model/bannerModel.js
import { bannerService } from '../services/bannerService';

/**
 * 轮播图数据模型
 */
export const BannerModel = {

  getBannerList: async (params) => {
    // 调用service层获取原始数据
    const response = await bannerService.getBanners(params);
    if (!response.ok) throw new Error('分类接口请求失败');
    const rawData = await response.json();
    return rawData?.result ?? [];
  },
};